import AlertBlock from "./AlertBlock";
import AccordionBlock from "./AccordionBlock";
import BulletListBlock from "./BulletListBlock";
import CalloutBlock from "./CalloutBlock";
import CodeBlock from "./CodeBlock";
import DividerBlock from "./DividerBlock";
import HeaderBlock from "./HeaderBlock";
import ImageBlock from "./ImageBlock";
import VideoBlock from "./VideoBlock";
import NumberedListBlock from "./NumberedListBlock";
import SectionTitleBlock from "./SectionTitleBlock";
import TableBlock from "./TableBlock";
import TextBlock from "./TextBlock";
import IframeBlock from "./IframeBlock";

const BlockRenderer = ({ block }) => {
  const renderSwitch = (block) => {
    switch (block.type) {
      case "header":
        return <HeaderBlock block={block} />;
      case "callout":
        return <CalloutBlock block={block} />;
      case "text":
        return <TextBlock block={block} />;
      case "num-list":
        return <NumberedListBlock block={block} />;
      case "bullet-list":
        return <BulletListBlock block={block} />;
      case "section-title":
        return <SectionTitleBlock block={block} />;
      case "image":
        return <ImageBlock block={block} />;
      case "video":
        return <VideoBlock block={block} />;
      case "code":
        return <CodeBlock block={block} />;
      case "iframe":
        return <IframeBlock block={block} />;
      case "alert":
        return <AlertBlock block={block} />;
      case "accordion":
        return <AccordionBlock block={block} />;
      case "table":
        return <TableBlock block={block} />;
      case "new-line":
        return <br />;
      case "divider":
        return <DividerBlock />;
      default:
        console.warn(`Block type not supported: ${block.type}`);
        return null;
    }
  };

  return <>{renderSwitch(block)}</>;
};

export default BlockRenderer;